var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var isPlainObject = function (value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
};
var deepMerge = function (base, patch) {
    var result = __assign({}, base);
    for (var _i = 0, _a = Object.keys(patch); _i < _a.length; _i++) {
        var key = _a[_i];
        var patchValue = patch[key];
        if (patchValue === undefined)
            continue;
        var baseValue = result[key];
        if (isPlainObject(baseValue) && isPlainObject(patchValue)) {
            result[key] = deepMerge(baseValue, patchValue);
            continue;
        }
        result[key] = patchValue;
    }
    return result;
};
var userReducer = function (items, action) {
    var _a, _b;
    switch (action.type) {
        case 'SET_PROFILE': {
            return __assign(__assign({}, items), { profile: __assign({}, action.item) });
        }
        case 'UPDATE_PROFILE': {
            return __assign(__assign({}, items), { profile: __assign(__assign({}, items.profile), action.item) });
        }
        case 'UPDATE_NALA_SETTINGS': {
            var nextNalaSettings = deepMerge(((_a = items.profile.nala_settings) !== null && _a !== void 0 ? _a : {}), action.item);
            return __assign(__assign({}, items), { profile: __assign(__assign({}, items.profile), { nala_settings: nextNalaSettings }) });
        }
        case 'SET_PERMISSIONS': {
            return __assign(__assign({}, items), { permissions: __spreadArray([], action.item, true) });
        }
        case 'SET_ACTIVE_FOLDER': {
            return __assign(__assign({}, items), { activeFolder: action.item
                    ? __assign(__assign({}, action.item), { file_ids: (_b = action.item.file_ids) !== null && _b !== void 0 ? _b : [] }) : null });
        }
        case 'SET_FILE_IDS': {
            if (!items.activeFolder) {
                return items;
            }
            return __assign(__assign({}, items), { activeFolder: __assign(__assign({}, items.activeFolder), { file_ids: action.fileIds }) });
        }
        case 'ADD_FILE_ID': {
            if (!items.activeFolder) {
                return items;
            }
            return __assign(__assign({}, items), { activeFolder: __assign(__assign({}, items.activeFolder), { file_ids: __spreadArray(__spreadArray([], items.activeFolder.file_ids, true), [action.fileId], false) }) });
        }
        case 'REMOVE_FILE_ID': {
            if (!items.activeFolder) {
                return items;
            }
            return __assign(__assign({}, items), { activeFolder: __assign(__assign({}, items.activeFolder), { file_ids: items.activeFolder.file_ids.filter(function (id) { return id !== action.fileId; }) }) });
        }
        case 'CLEAR_FILE_IDS': {
            if (!items.activeFolder) {
                return items;
            }
            return __assign(__assign({}, items), { activeFolder: __assign(__assign({}, items.activeFolder), { file_ids: [] }) });
        }
        case 'CLEAR_ACTIVE_FOLDER': {
            return __assign(__assign({}, items), { activeFolder: null });
        }
        default: {
            var exhaustiveCheck = action;
            throw Error("UserReducer: Unhandled action type ".concat(String(exhaustiveCheck)));
        }
    }
};
export default userReducer;
